export type { VeroPageProps } from './VeroPage/VeroPage';
export { default as VeroPage } from './VeroPage/VeroPage';